<div class="d-flex flex-column gap-3">
  @for (
    item of sortedRateItems();
    track $index;
    let isFirst = $first;
    let count = $count
  ) {
    <div class="d-flex gap-3">
      <gstar-rate-field
        [isDisabled]="isReadonly()"
        [securityTaxResultItemForm]="item!"
        class="column-tax-result gstar-rate-field"
        (update)="updateHandler($event, item)" />
      @if (!isReadonly()) {
        <div>
          @if (isFirst) {
            <div>
              <ap-button
                [disabled]="count >= 10"
                icon="plus-outline"
                [add]="true"
                (click)="add(item.rate!.metadata)" />
            </div>
          } @else if (count > 1) {
            <div>
              <ap-button
                btnType="text"
                icon="delete-outline"
                (click)="deleteRate(item)" />
            </div>
          }
        </div>
      }
    </div>
  }
</div>
